// extracted by mini-css-extract-plugin
module.exports = {"root":"CenterOfAttention__root___LunQA","centerOfAttentionText":"CenterOfAttention__centerOfAttentionText___ebojF"};